export default "__VITE_ASSET__CBxe7wjj__"